import React from 'react';
import { Container, Typography, Box, CircularProgress, Alert } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useQrCodeAccess } from '../../utils/useQrCodeAccess';

export default function CompletionPage() {
    const { loading, error: qrError, tokenValid, uuid } = useQrCodeAccess('complete');
    const location = useLocation();
    const { targetText } = location.state || {};
    const envelopeShort = uuid ? uuid.split('-')[0] : '';



    if (loading) {
        return <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}><CircularProgress /></Container>;
    }
    if (qrError || tokenValid === false) {
        let errorMsg = 'Chave de acesso não informada ou incorreta.';
        if (qrError) errorMsg = qrError;
        if (tokenValid === false) errorMsg = 'Token inválido. Acesso não autorizado.';
        return (
            <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
                <Alert severity="error">{errorMsg}</Alert>
            </Container>
        );
    }
    if (tokenValid === null) {
        return null;
    }

    return (
        <Container maxWidth="sm" sx={{ mt: 4, textAlign: 'center' }}>
            <Typography variant="h5" gutterBottom>Coleta Concluída!</Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>Obrigado por sua participação.</Typography>
            <Box sx={{ p: 2, border: '1px solid #ccc', borderRadius: '4px', background: '#f9f9f9', mb: 3 }}>
                <Typography variant="h6">Texto Alvo (Sessão Envelope {envelopeShort}):</Typography>
                <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>{targetText || "(Texto alvo não disponível)"}</Typography>
            </Box>
        </Container>
    );
}
